import React, { useState, useEffect, useMemo } from "react";
import ReactQuill from "react-quill";
import Select from "react-select";
import CreatableSelect from "react-select/creatable";
import { useSelector, useDispatch } from "react-redux";
import { selectCid } from "../features/companyid";
import { selectUuid } from "../features/userid";
import axiosInstance from "../axiosInstance";
import { server_API } from "../config";
import { useLocation } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import { useRef } from "react";
import html2pdf from "html2pdf.js";
import { FaRegSave } from "react-icons/fa";
import edit from "../images/edit_black.png";
import download_black from "../images/download_balck.png";
import { TailSpin } from "react-loader-spinner";
import axios from "axios";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { onlyContainsNumbers } from "../utils/stringUtils";
import { getCurrencySymbol, formatSalary } from "../utils/currencyUtils";
import { formatDateToShortMonth } from "../utils/dateUtils";

const JobDetails = (props) => {
  const location = useLocation();
  const { id } = location.state || {}; // Handle potential null state
  // const { id } = location.state;
  const companyId = useSelector(selectCid);

  const [companyCountryCode, setCompanyCountryCode] = useState("IN"); // Default to IN

  // Fetch enriched job (currency_symbol, formatted_salary_*, phone_code) from API
  // so symbol and salary always match company country, even if parent passed list-item job
  // We always expect props.job to be passed
  const jobDetails = props.job;

  // Use frontend utils for formatting with company-level country code
  const currencySymbol = getCurrencySymbol(companyCountryCode);

  const formattedSalaryFrom = formatSalary(
    jobDetails?.salaryfrom,
    companyCountryCode,
  );

  const formattedSalaryTo = formatSalary(
    jobDetails?.salaryto,
    companyCountryCode,
  );

  const [jtype, setType] = useState(jobDetails.jobtype);
  const [recruiter, setRecuiter] = useState(jobDetails.assignrecruiter);
  const [manager, setManager] = useState(jobDetails.assignhiringmanager);
  const [allUsers, setAllUsers] = useState([]);
  const [recruiters, setRecruiters] = useState([]);
  const [flag, setFlag] = useState(false);
  const [formattedAllUsers, setFormattedAllUsers] = useState([]);
  const [privilege, setPrivilege] = useState("");
  const [noOfPositions, setNoOfPositions] = useState(jobDetails.positionnumber);
  const [jobdescription, setJobDescription] = useState(
    jobDetails.jobdescription,
  );
  const [additionalRecruitersAndHrms, setAdditionalRecruitersAndHrms] =
    useState({
      additionalRecruiters: [],
      additionalHrms: [],
    });
  const [loader, setLoader] = useState(false);

  const [hasAiCalling, setHasAiCalling] = useState(false);

  const [department, setDepartment] = useState(jobDetails.department);
  const [grade, setGrade] = useState(jobDetails.grade || "");

  const [techQuestions, setTechQuestions] = useState([]);
  const [majorCitiesOptions, setMajorCitiesOptions] = useState([]);
  const [title, setTitle] = useState(jobDetails.profilename);
  const [isEdit, setIsEdit] = useState(false);
  const [departments, setDepartments] = useState([]);
  const [activeGrades, setActiveGrades] = useState([]);
  const [isSalaryVisible, setIsSalaryVisible] = useState(true);
  const [fromAcfl, setFromAcfl] = useState(false);
  const [minDob, setMinDob] = useState(jobDetails.min_dob || "");
  const [minEducation, setMinEducation] = useState(
    jobDetails.min_education || "",
  );
  const [positionType, setPositionType] = useState(
    jobDetails.position_type || "",
  );
  const [newPositionComments, setNewPositionComments] = useState(
    jobDetails.new_position_comments || "",
  );
  const [activeEmployeesSameGrade, setActiveEmployeesSameGrade] = useState(
    jobDetails.acfl_detail?.active_employees_same_grade || "",
  );
  const [minSalarySameGrade, setMinSalarySameGrade] = useState(
    jobDetails.acfl_detail?.min_salary_same_grade || "",
  );
  const [maxSalarySameGrade, setMaxSalarySameGrade] = useState(
    jobDetails.acfl_detail?.max_salary_same_grade || "",
  );
  const [replacementEmployeeName, setReplacementEmployeeName] = useState(
    jobDetails.acfl_detail?.replacement_employee_name || "",
  );
  const [replacementEmployeeCode, setReplacementEmployeeCode] = useState(
    jobDetails.acfl_detail?.replacement_employee_code || "",
  );
  const [replacementEmployeeLocation, setReplacementEmployeeLocation] =
    useState(jobDetails.acfl_detail?.replacement_employee_location || "");
  const [replacementEmployeeDesignation, setReplacementEmployeeDesignation] =
    useState(jobDetails.acfl_detail?.replacement_employee_designation || "");
  const [manualTrigger, setManualTrigger] = useState(
    jobDetails.manual_trigger || false,
  );
  const [trigger, setTrigger] = useState(jobDetails.resume_threshold);
  const [aiCalling, setAiCalling] = useState(jobDetails.aicalling || false);
  const [Loader, setLoaders] = useState(false);

  const [isGeneratingPDF, setIsGeneratingPDF] = useState(false);


  const handleDownload = () => {
    setIsGeneratingPDF(true);
    const element = document.getElementById("jobDetailsPDF");

    const options = {
      filename: `${jobDetails.profilename}_Details.pdf`, // PDF file name
      image: { type: "jpeg", quality: 0.98 }, // Screenshot quality
      html2canvas: { scale: 2 }, // Higher scale = better quality, useCORS = needed if images come from a different origin
      jsPDF: {
        unit: "in",
        format: "a4",
        orientation: "portrait",
        margins: { top: 0.5, bottom: 0.5, right: 0.5, left: 0.5 },
      }, // PDF size & layout
      pagebreak: {
        mode: ["css", "legacy"],
        before: ".page-break",
      },
    };

    html2pdf()
      .from(element)
      .set(options)
      .save()
      .then(() => {
        setIsGeneratingPDF(false);
      });
  };

  useEffect(() => {
    axios
      .get(
        `${server_API}/v2/question/get/${jobDetails.questionid}/${companyId}`,
      )
      .then((response) => {
        console.log("questions", response);
        setTechQuestions(response.data.questions);
        setLoader(false);
      })
      .catch((error) => {
        console.log(error);
        setLoader(false);
      });
  }, []);

  const jobSubmit = () => {
    setLoaders(true);
    const editedLocationsString = editedLocations.map((l) => {
      return l.value;
    });

    const toOptionalInt = (value) => {
      if (value === null || value === undefined) return undefined;
      const trimmed = String(value).trim();
      if (!trimmed) return undefined;
      const parsed = Number(trimmed);
      return Number.isFinite(parsed) ? parsed : undefined;
    };

    const acflDetailPayload = fromAcfl
      ? {
        ...(toOptionalInt(activeEmployeesSameGrade) !== undefined && {
          active_employees_same_grade: toOptionalInt(activeEmployeesSameGrade),
        }),
        ...(toOptionalInt(minSalarySameGrade) !== undefined && {
          min_salary_same_grade: toOptionalInt(minSalarySameGrade),
        }),
        ...(toOptionalInt(maxSalarySameGrade) !== undefined && {
          max_salary_same_grade: toOptionalInt(maxSalarySameGrade),
        }),
        ...(replacementEmployeeName?.trim() && {
          replacement_employee_name: replacementEmployeeName.trim(),
        }),
        ...(replacementEmployeeCode?.trim() && {
          replacement_employee_code: replacementEmployeeCode.trim(),
        }),
        ...(replacementEmployeeLocation?.trim() && {
          replacement_employee_location: replacementEmployeeLocation.trim(),
        }),
        ...(replacementEmployeeDesignation?.trim() && {
          replacement_employee_designation:
            replacementEmployeeDesignation.trim(),
        }),
      }
      : null;

    console.log(editedLocationsString);
    axios
      .patch(`${server_API}/v2/job/update`, {
        companyid: companyId,
        uuid: id,
        profilename: title,
        positionnumber: parseInt(noOfPositions),
        department: department,
        grade: grade,
        jobtype: jtype,
        location: editedLocationsString.toString(),
        assignrecruiter: recruiter,
        assignhiringmanager: manager,
        displaysalary: isSalaryVisible,
        jobdescription: jobdescription,
        additional_recruiters:
          additionalRecruitersAndHrms.additionalRecruiters
            ?.filter(Boolean)
            .map((recruiter) => recruiter?.value)
            .filter(Boolean) || [],
        additional_hrms:
          additionalRecruitersAndHrms.additionalHrms
            ?.filter(Boolean)
            .map((hrm) => hrm?.value)
            .filter(Boolean) || [],
        position_type: positionType,
        new_position_comments: newPositionComments,
        min_dob: minDob,
        min_education: minEducation,
        manual_trigger: manualTrigger,
        resume_threshold: !manualTrigger ? trigger : 0,
        aicalling: aiCalling,
        ...(fromAcfl &&
          acflDetailPayload &&
          Object.keys(acflDetailPayload).length > 0 && {
          acfl_detail: {
            ...acflDetailPayload,
          },
        }),
      })
      .then((res) => {
        setLoaders(false);
        setIsEdit(false);
        toast("Job details are edited successfully", {
          position: "top-right",
          className: "bg-green-500 text-white",
        });
        window.location.reload();
      });
  };
  console.log(isEdit);
  const jobtypeoptions = [
    { value: "", label: "Select Job Type" },
    { value: "Full-time", label: "Full-Time" },
    { value: "Part-time", label: "Part-Time" },
    { value: "Internship", label: "Internship" },
  ];
  const departmentoptions = [
    { value: "", label: "--" },
    ...departments.map((d) => ({ value: d, label: d })),
  ];
  const gradeOptions = activeGrades.map((item) => ({
    value: item.grade,
    label: `${item.title} (${item.grade})`,
  }));
  const [editedLocations, setEditedLocations] = useState([]);
  const handleLocationsChange = (selectedOptions, actionMeta) => {
    // Prevent removing fixed options
    if (
      actionMeta.action === "remove-value" ||
      actionMeta.action === "pop-value"
    ) {
      if (actionMeta.removedValue && actionMeta.removedValue.isFixed) {
        return;
      }
    }

    // If cleared, restore fixed options
    if (actionMeta.action === "clear") {
      const fixed = editedLocations.filter((loc) => loc.isFixed);
      setEditedLocations(fixed);
      return;
    }

    // Update state with selected options (or empty array if null)
    setEditedLocations(selectedOptions || []);
  };

  useEffect(() => {
    if (allUsers.length > 0) {
      if (flag == false) {
        const users = allUsers.filter((item) => {
          if (item.status == "accepted") {
            Object.defineProperty(
              item,
              "value",
              Object.getOwnPropertyDescriptor(item, "uuid"),
            );
            Object.defineProperty(
              item,
              "label",
              Object.getOwnPropertyDescriptor(item, "name"),
            );
            return item;
          }
        });
        setFormattedAllUsers(users);
        setFlag(true);
      }
      const editorOrViewers = allUsers.filter((f) => {
        if (f.status == "accepted") {
          Object.defineProperty(
            f,
            "value",
            Object.getOwnPropertyDescriptor(f, "uuid"),
          );
          Object.defineProperty(
            f,
            "label",
            Object.getOwnPropertyDescriptor(f, "name"),
          );
          return f;
        }
      });
      setRecruiters(
        editorOrViewers.filter((f) => {
          return f.privilege !== "Hiring Manager";
        }),
      );
      setAdditionalRecruitersAndHrms({
        additionalRecruiters:
          jobDetails.additional_recruiters
            ?.map((recruiter) =>
              editorOrViewers.find((user) => user.value === recruiter),
            )
            ?.filter(Boolean) || [],
        additionalHrms:
          jobDetails.additional_hrms
            ?.map((hrm) => editorOrViewers.find((user) => user.value === hrm))
            ?.filter(Boolean) || [],
      });
    }
  }, [allUsers]);

  const majorCities = [
    { label: "Delhi", value: "Delhi" },
    { label: "Mumbai", value: "Mumbai" },
    { label: "Kolkata", value: "Kolkata" },
    { label: "Chennai", value: "Chennai" },
    { label: "Jaipur", value: "Jaipur" },
    { label: "Pune", value: "Pune" },
    { label: "Ahmedabad", value: "Ahmedabad" },
    { label: "Bangalore", value: "Bangalore" },
    { label: "Hyderabad", value: "Hyderabad" },
    { label: "Surat", value: "Surat" },
    { label: "Agra", value: "Agra" },
    { label: "Kanpur", value: "Kanpur" },
    { label: "Lucknow", value: "Lucknow" },
    { label: "Nagpur", value: "Nagpur" },
    { label: "Indore", value: "Indore" },
    { label: "Bhopal", value: "Bhopal" },
    { label: "Chandigarh", value: "Chandigarh" },
    { label: "Patna", value: "Patna" },
    { label: "Dehradun", value: "Dehradun" },
    { label: "Coimbatore", value: "Coimbatore" },
    { label: "Madurai", value: "Madurai" },
    { label: "Vijayawada", value: "Vijayawada" },
    { label: "Mangalore", value: "Mangalore" },
    { label: "Mysore", value: "Mysore" },
    { label: "Trivandrum", value: "Trivandrum" },
    { label: "Tirupati", value: "Tirupati" },
    { label: "Nellore", value: "Nellore" },
    { label: "Guntur", value: "Guntur" },
    { label: "Warangal", value: "Warangal" },
    { label: "Kurnool", value: "Kurnool" },
    { label: "Rajahmundry", value: "Rajahmundry" },
    { label: "Bhubaneswar", value: "Bhubaneswar" },
    { label: "Guwahati", value: "Guwahati" },
    { label: "Ranchi", value: "Ranchi" },
    { label: "Jamshedpur", value: "Jamshedpur" },
    { label: "Cuttack", value: "Cuttack" },
    { label: "Durgapur", value: "Durgapur" },
    { label: "Asansol", value: "Asansol" },
    { label: "Siliguri", value: "Siliguri" },
    { label: "Dhanbad", value: "Dhanbad" },
    { label: "Rourkela", value: "Rourkela" },
    { label: "Haldia", value: "Haldia" },
    { label: "Agartala", value: "Agartala" },
    { label: "Shillong", value: "Shillong" },
    { label: "Imphal", value: "Imphal" },
    { label: "Kohima", value: "Kohima" },
    { label: "Aizawl", value: "Aizawl" },
    { label: "Gangtok", value: "Gangtok" },
    { label: "Itanagar", value: "Itanagar" },
    { label: "Dimapur", value: "Dimapur" },
    { label: "Silchar", value: "Silchar" },
    { label: "Dibrugarh", value: "Dibrugarh" },
    { label: "Tripura", value: "Tripura" },
    { label: "Jorhat", value: "Jorhat" },
    { label: "Gurugram", value: "Gurugram" },
  ];

  const rid = useSelector(selectUuid);
  useEffect(() => {
    window.scrollTo(0, 0);
    axiosInstance
      .get(`/v2/company/get/${companyId}`)
      .then((response) => {
        if (response.data.departments) {
          setDepartments(response.data.departments);
        } else {
          setDepartments([]);
        }
        setFromAcfl(response.data.from_acfl || false);
        setHasAiCalling(response.data.auto_calling || false);
        const usableGrades = (response.data.grades || []).filter(
          (item) => item?.use_in_job_workflows && item?.title && item?.grade,
        );
        setActiveGrades(usableGrades);

        if (
          response.data.company_countries &&
          response.data.company_countries.length > 0
        ) {
          setCompanyCountryCode(response.data.company_countries[0]);
        }

        axiosInstance
          .get(`${server_API}/v2/user/company/${companyId}`)
          .then((response) => {
            setAllUsers(response.data.message.Users);
          })
          .catch((err) => {
            setAllUsers([]);
          });
      })
      .catch((error) => {
        setDepartments([]);
        console.log(error);
      });

    axiosInstance
      .get(`/v2/user/getuser`)
      .then((res) => {
        setPrivilege(res.data.success.privilege);
      })
      .catch((err) => {
        console.log(err);
      });
  }, []);

  useEffect(() => {
    if (
      !jobDetails ||
      typeof jobDetails !== "object" ||
      Object.keys(jobDetails).length === 0
    )
      return;
    let existingLocations = (jobDetails["location:"] || "")
      .split(",")
      .filter(Boolean);
    let existinLocations = existingLocations.map((l) => {
      return { value: l, label: l, isFixed: true };
    });
    setEditedLocations(existinLocations);

    const m = majorCities.map((m) => {
      if (existingLocations.includes(m.value)) {
        return { value: m.value, label: m.label, isFixed: true };
      } else {
        return { value: m.value, label: m.label, isFixed: false };
      }
    });
    setMajorCitiesOptions(m);

    setMinDob(jobDetails.min_dob || "");
    setMinEducation(jobDetails.min_education || "");
    setGrade(jobDetails.grade || "");
    setPositionType(jobDetails.position_type || "");
    setNewPositionComments(jobDetails.new_position_comments || "");
    setActiveEmployeesSameGrade(
      jobDetails.acfl_detail?.active_employees_same_grade || "",
    );
    setMinSalarySameGrade(jobDetails.acfl_detail?.min_salary_same_grade || "");
    setMaxSalarySameGrade(jobDetails.acfl_detail?.max_salary_same_grade || "");
    setReplacementEmployeeName(
      jobDetails.acfl_detail?.replacement_employee_name || "",
    );
    setReplacementEmployeeCode(
      jobDetails.acfl_detail?.replacement_employee_code || "",
    );
    setReplacementEmployeeLocation(
      jobDetails.acfl_detail?.replacement_employee_location || "",
    );
    setReplacementEmployeeDesignation(
      jobDetails.acfl_detail?.replacement_employee_designation || "",
    );
    setManualTrigger(jobDetails.manual_trigger || false);
    setTrigger(jobDetails.resume_threshold || 0);
    setAiCalling(jobDetails.aicalling || false);
    setIsSalaryVisible(jobDetails.displaysalary);
  }, [jobDetails]);

  const getSelectedUserIds = () => {
    const ids = new Set();
    if (recruiter) ids.add(recruiter);
    if (manager) ids.add(manager);
    additionalRecruitersAndHrms.additionalRecruiters?.forEach(
      (u) => u && ids.add(u.value),
    );
    additionalRecruitersAndHrms.additionalHrms?.forEach(
      (u) => u && ids.add(u.value),
    );
    return ids;
  };

  const selectedUserIds = getSelectedUserIds();

  const getFilteredOptions = (baseOptions, currentValues = []) => {
    const currentIds = new Set();
    if (Array.isArray(currentValues)) {
      currentValues.forEach((v) => v && currentIds.add(v.value));
    } else if (currentValues) {
      currentIds.add(currentValues);
    }

    return baseOptions.filter(
      (option) =>
        !selectedUserIds.has(option.value) || currentIds.has(option.value),
    );
  };
  return (
    <div className="bg-white">
      <div
        className={`${isGeneratingPDF ? "pdf-mode" : ""}`}
        id="jobDetailsPDF"
      >
        <div className="mb-10">
          <div className=" rounded-xl ">
            <div className="flex flex-col ">
              <div className="p-6 flex gap-4 justify-between">
                <div className="flex flex-col gap-4 w-[80%]">
                  <div className="flex w-full gap-4">
                    <div className="w-1/2 flex items-center ">
                      <p className="font-semibold w-1/3">
                        Job title:{" "}
                        {isEdit && <span className="text-red-500">*</span>}
                      </p>
                      {isEdit ? (
                        <input
                          onChange={(e) => setTitle(e.target.value)}
                          value={title}
                          autocapitalize="word"
                          style={{ textTransform: "capitalize" }}
                          className="outline-none border px-3 py-2 w-3/5 rounded-lg"
                        />
                      ) : (
                        <span className="text-[#8F94A1] font-normal">
                          {jobDetails.profilename}
                        </span>
                      )}
                    </div>

                    <div className="w-1/2 flex items-center">
                      <p className="font-semibold w-1/3">
                        Job type:{" "}
                        {isEdit && <span className="text-red-500">*</span>}
                      </p>
                      {isEdit ? (
                        <Select
                          value={jobtypeoptions.find(
                            (option) => option.value === jtype,
                          )}
                          onChange={(selectedOption) =>
                            setType(selectedOption.value)
                          }
                          options={jobtypeoptions}
                          className="w-3/5"
                        />
                      ) : (
                        <span className="text-[#8F94A1] font-normal">
                          {jobDetails.jobtype}
                        </span>
                      )}
                    </div>
                  </div>

                  {/* Second Row - No of Openings & Department */}
                  <div className="flex w-full gap-4">
                    <div className="w-1/2 flex items-center ">
                      <p className="font-semibold w-1/3">
                        No of openings:{" "}
                        {isEdit && <span className="text-red-500">*</span>}
                      </p>
                      {isEdit ? (
                        <input
                          value={noOfPositions}
                          onChange={(e) => setNoOfPositions(e.target.value)}
                          className="w-3/5 outline-none border px-3 py-2 rounded-lg"
                          type="text"
                        />
                      ) : (
                        <span className="text-[#8F94A1] font-normal">
                          {jobDetails.positionnumber}
                        </span>
                      )}
                    </div>

                    <div className="w-1/2 flex items-center">
                      <p className="font-semibold w-1/3">
                        Department:{" "}
                        {isEdit && <span className="text-red-500">*</span>}
                      </p>
                      {isEdit ? (
                        <Select
                          value={departmentoptions.find(
                            (option) => option.value === department,
                          )}
                          onChange={(selectedOption) =>
                            setDepartment(selectedOption.value)
                          }
                          options={departmentoptions}
                          className="w-3/5"
                        />
                      ) : (
                        <span className="text-[#8F94A1] font-normal">
                          {jobDetails.department}
                        </span>
                      )}
                    </div>
                  </div>

                  {/* Fourth Row - Salary From & Salary To */}
                  {((isEdit && gradeOptions.length > 0) || (!isEdit && jobDetails.grade)) && (
                    <div className="flex w-full gap-4">
                      <div className="w-1/2 flex items-center">
                        <p className="font-semibold w-1/3">Grade:</p>
                        {isEdit && gradeOptions.length > 0 ? (
                          <Select
                            value={gradeOptions.find(
                              (option) => option.value === grade,
                            ) || null}
                            onChange={(selectedOption) =>
                              setGrade(selectedOption ? selectedOption.value : "")
                            }
                            options={gradeOptions}
                            className="w-3/5"
                            isClearable
                            placeholder="Select grade"
                          />
                        ) : (
                          <span className="text-[#8F94A1] font-normal">
                            {jobDetails.grade}
                          </span>
                        )}
                      </div>
                    </div>
                  )}

                  {/* Fourth Row - Salary From & Salary To */}
                  <div className="flex w-full gap-4">
                    <div className="w-1/2 flex items-center">
                      <p className="font-semibold w-1/3">Annual Salary:</p>
                      <span className="text-[#8F94A1] font-normal">
                        {formattedSalaryFrom === "-" &&
                          formattedSalaryTo === "-"
                          ? "-"
                          : `${currencySymbol}${formattedSalaryFrom} - ${currencySymbol}${formattedSalaryTo}`}
                      </span>
                    </div>
                    <div className="w-1/2 flex items-center">
                      <p className="font-semibold w-1/3">Experience:</p>
                      <span className="text-[#8F94A1] font-normal">
                        {jobDetails.experience}
                      </span>
                    </div>
                  </div>

                  {/* Fifth Row - Location & Work Style */}
                  <div className="flex w-full gap-4">
                    <div className="w-1/2 flex items-center">
                      <p className="font-semibold w-1/3">
                        Location:{" "}
                        {isEdit && <span className="text-red-500">*</span>}
                      </p>
                      {isEdit ? (
                        <CreatableSelect
                          value={editedLocations}
                          onChange={handleLocationsChange}
                          options={majorCitiesOptions}
                          isClearable={editedLocations.some((v) => !v.isFixed)}
                          isMulti
                          isSearchable
                          placeholder="Select or create a city..."
                          className="w-3/5"
                        />
                      ) : (
                        <span className="text-[#8F94A1] font-normal">
                          {jobDetails["location:"]?.replace(/,/g, ", ")}
                        </span>
                      )}
                    </div>

                    <div className="w-1/2 flex items-center">
                      <p className="font-semibold w-1/3">Work style:</p>
                      <span className="text-[#8F94A1] font-normal">
                        {jobDetails.workstyle}
                      </span>
                    </div>
                  </div>

                  {fromAcfl && <div className="flex w-full gap-4">
                    <div className="w-1/2 flex items-center">
                      <p className="font-semibold w-1/3">Type of Position:</p>
                      {isEdit ? (
                        <div className="flex items-center space-x-4 w-3/5">
                          <label className="flex items-center space-x-1">
                            <input
                              type="radio"
                              value="New"
                              checked={positionType === "New"}
                              onChange={(e) => setPositionType(e.target.value)}
                            />
                            <span>New</span>
                          </label>
                          <label className="flex items-center space-x-1">
                            <input
                              type="radio"
                              value="Replacement"
                              checked={positionType === "Replacement"}
                              onChange={(e) => setPositionType(e.target.value)}
                            />
                            <span>Replacement</span>
                          </label>
                        </div>
                      ) : (
                        <span className="text-[#8F94A1] font-normal">
                          {positionType}
                        </span>
                      )}
                    </div>
                    {positionType === "New" && (
                      <div className="w-1/2 flex items-center">
                        <p className="font-semibold w-1/3">Comments:</p>
                        {isEdit ? (
                          <input
                            value={newPositionComments}
                            onChange={(e) =>
                              setNewPositionComments(e.target.value)
                            }
                            className="w-3/5 outline-none border px-3 py-2 rounded-lg"
                          />
                        ) : (
                          <span className="text-[#8F94A1] font-normal">
                            {newPositionComments}
                          </span>
                        )}
                      </div>
                    )}
                  </div>}

                  {positionType === "Replacement" && (
                    <>
                      <div className="flex w-full gap-4">
                        <div className="w-1/2 flex items-center">
                          <p className="font-semibold w-1/3">Repl. Name:</p>
                          {isEdit ? (
                            <input
                              value={replacementEmployeeName}
                              onChange={(e) =>
                                setReplacementEmployeeName(e.target.value)
                              }
                              className="w-3/5 outline-none border px-3 py-2 rounded-lg"
                            />
                          ) : (
                            <span className="text-[#8F94A1] font-normal">
                              {replacementEmployeeName}
                            </span>
                          )}
                        </div>
                        <div className="w-1/2 flex items-center">
                          <p className="font-semibold w-1/3">Repl. Code:</p>
                          {isEdit ? (
                            <input
                              value={replacementEmployeeCode}
                              onChange={(e) =>
                                setReplacementEmployeeCode(e.target.value)
                              }
                              className="w-3/5 outline-none border px-3 py-2 rounded-lg"
                            />
                          ) : (
                            <span className="text-[#8F94A1] font-normal">
                              {replacementEmployeeCode}
                            </span>
                          )}
                        </div>
                      </div>
                      <div className="flex w-full gap-4">
                        <div className="w-1/2 flex items-center">
                          <p className="font-semibold w-1/3">Repl. Location:</p>
                          {isEdit ? (
                            <input
                              value={replacementEmployeeLocation}
                              onChange={(e) =>
                                setReplacementEmployeeLocation(e.target.value)
                              }
                              className="w-3/5 outline-none border px-3 py-2 rounded-lg"
                            />
                          ) : (
                            <span className="text-[#8F94A1] font-normal">
                              {replacementEmployeeLocation}
                            </span>
                          )}
                        </div>
                        <div className="w-1/2 flex items-center">
                          <p className="font-semibold w-1/3">Repl. Design.:</p>
                          {isEdit ? (
                            <input
                              value={replacementEmployeeDesignation}
                              onChange={(e) =>
                                setReplacementEmployeeDesignation(
                                  e.target.value,
                                )
                              }
                              className="w-3/5 outline-none border px-3 py-2 rounded-lg"
                            />
                          ) : (
                            <span className="text-[#8F94A1] font-normal">
                              {replacementEmployeeDesignation}
                            </span>
                          )}
                        </div>
                      </div>
                    </>
                  )}

                  {hasAiCalling && (
                    <div className="flex w-full gap-4">
                      <div className="w-1/2 flex items-center">
                        <p className="font-semibold w-1/3">AI Calling:</p>
                        {isEdit ? (
                          <div className="flex items-center space-x-4 w-3/5">
                            <label className="flex items-center space-x-1">
                              <input
                                type="radio"
                                name="aiCalling"
                                checked={aiCalling}
                                onChange={() => setAiCalling(true)}
                              />
                              <span>Yes</span>
                            </label>
                            <label className="flex items-center space-x-1">
                              <input
                                type="radio"
                                name="aiCalling"
                                checked={!aiCalling}
                                onChange={() => setAiCalling(false)}
                              />
                              <span>No</span>
                            </label>
                          </div>
                        ) : (
                          <span className="text-[#8F94A1] font-normal">
                            {aiCalling ? "Yes" : "No"}
                          </span>
                        )}
                      </div>
                    </div>
                  )}

                  <div className="flex w-full gap-4">
                    <div className="w-full flex items-center gap-6">
                      <p className="font-semibold whitespace-nowrap">
                        Display Salary Range to Candidates:
                      </p>
                      {isEdit ? (
                        <div className="flex items-center space-x-4">
                          <label className="flex items-center space-x-1 cursor-pointer">
                            <input
                              type="radio"
                              name="displaysalary"
                              value="yes"
                              checked={isSalaryVisible === true}
                              onChange={() => setIsSalaryVisible(true)}
                              className="cursor-pointer"
                            />
                            <span>Yes</span>
                          </label>
                          <label className="flex items-center space-x-1 cursor-pointer">
                            <input
                              type="radio"
                              name="displaysalary"
                              value="no"
                              checked={isSalaryVisible === false}
                              onChange={() => setIsSalaryVisible(false)}
                              className="cursor-pointer"
                            />
                            <span>No</span>
                          </label>
                        </div>
                      ) : (
                        <span className="text-[#8F94A1] font-normal">
                          {jobDetails.displaysalary ? "Yes" : "No"}
                        </span>
                      )}
                    </div>
                  </div>

                  {fromAcfl && (
                    <>
                      <div className="flex w-full gap-4">
                        <div className="w-1/2 flex items-center">
                          <p className="font-semibold w-1/3">Maximum DOB:</p>
                          {isEdit ? (
                            <input
                              type="date"
                              value={minDob}
                              onChange={(e) => setMinDob(e.target.value)}
                              className="w-3/5 outline-none border px-3 py-2 rounded-lg"
                            />
                          ) : (
                            <span className="text-[#8F94A1] font-normal">
                              {minDob}
                            </span>
                          )}
                        </div>
                        <div className="w-1/2 flex items-center">
                          <p className="font-semibold w-1/3">
                            Minimum Education:
                          </p>
                          {isEdit ? (
                            <Select
                              value={
                                minEducation
                                  ? { value: minEducation, label: minEducation }
                                  : null
                              }
                              onChange={(opt) => setMinEducation(opt.value)}
                              options={[
                                { value: "10th", label: "10th" },
                                { value: "12th", label: "12th" },
                                { value: "Diploma", label: "Diploma" },
                                {
                                  value: "Bachelors/Graduations",
                                  label: "Bachelors/Graduations",
                                },
                                {
                                  value: "Masters/Post Graduation",
                                  label: "Masters/Post Graduation",
                                },
                                { value: "PhD", label: "PhD" },
                              ]}
                              className="w-3/5"
                            />
                          ) : (
                            <span className="text-[#8F94A1] font-normal">
                              {minEducation}
                            </span>
                          )}
                        </div>
                      </div>

                      <div className="flex w-full gap-4">
                        <div className="w-1/2 flex items-center">
                          <p className="font-semibold w-1/3">
                            Min. Sal. (Grade):
                          </p>
                          {isEdit ? (
                            <input
                              value={minSalarySameGrade}
                              onChange={(e) => {
                                if (onlyContainsNumbers(e.target.value))
                                  setMinSalarySameGrade(e.target.value);
                              }}
                              className="w-3/5 outline-none border px-3 py-2 rounded-lg"
                            />
                          ) : (
                            <span className="text-[#8F94A1] font-normal">
                              {currencySymbol} {formatSalary(minSalarySameGrade, companyCountryCode)}
                            </span>
                          )}
                        </div>
                        <div className="w-1/2 flex items-center">
                          <p className="font-semibold w-1/3">
                            Max. Sal. (Grade):
                          </p>
                          {isEdit ? (
                            <input
                              value={maxSalarySameGrade}
                              onChange={(e) => {
                                if (onlyContainsNumbers(e.target.value))
                                  setMaxSalarySameGrade(e.target.value);
                              }}
                              className="w-3/5 outline-none border px-3 py-2 rounded-lg"
                            />
                          ) : (
                            <span className="text-[#8F94A1] font-normal">
                              {currencySymbol} {formatSalary(maxSalarySameGrade, companyCountryCode)}
                            </span>
                          )}
                        </div>
                      </div>

                      <div className="flex w-full gap-4">
                        <div className="w-1/2 flex items-center">
                          <p className="font-semibold w-1/3">Active Empls:</p>
                          {isEdit ? (
                            <input
                              value={activeEmployeesSameGrade}
                              onChange={(e) => {
                                if (onlyContainsNumbers(e.target.value))
                                  setActiveEmployeesSameGrade(e.target.value);
                              }}
                              className="w-3/5 outline-none border px-3 py-2 rounded-lg"
                            />
                          ) : (
                            <span className="text-[#8F94A1] font-normal">
                              {activeEmployeesSameGrade}
                            </span>
                          )}
                        </div>
                      </div>
                    </>
                  )}
                  {/* Third Row - Last Date to Apply & Experience */}
                  <div className="flex w-full gap-4">
                    {/* <div className="w-1/2 flex items-center ">
    <p className="font-semibold w-1/3">Last date to apply:</p>
    <span className="text-[#8F94A1] font-normal">
      {jobDetails.applicationlastdate.split("-")[2]}-
      {jobDetails.applicationlastdate.split("-")[1]}-
      {jobDetails.applicationlastdate.split("-")[0]}
    </span>
  </div> */}
                  </div>
                </div>

                {!isGeneratingPDF && (
                  <div className="w-[20%] flex gap-2 justify-end">
                    {!isEdit ? (
                      <>
                        {(privilege == "Admin" ||
                          rid === jobDetails?.assignrecruiter) &&
                          jobDetails.jobstatus !== "Closed" && (
                            <div
                              onClick={() => {
                                setIsEdit(true);
                              }}
                              className="bg-[#F1F4FB] p-1.5 rounded-md tooltip flex justify-center items-center h-fit"
                            >
                              <img
                                src={edit}
                                className="text-slate-700 cursor-pointer w-4 h-4"
                              />{" "}
                              <p className="tooltiptext ">Edit</p>
                            </div>
                          )}
                        <button
                          onClick={() => {
                            handleDownload();
                          }}
                          className="bg-[#F1F4FB] p-1.5 rounded-md tooltip flex justify-center items-center h-fit"
                        >
                          <img
                            src={download_black}
                            className="text-slate-700 cursor-pointer w-4 h-4"
                          />{" "}
                          <p className="tooltiptext ">Download</p>
                        </button>
                      </>
                    ) : (
                      <button
                        onClick={() => {
                          jobSubmit();
                        }}
                        className="bg-[#F1F4FB] p-1.5 rounded-md tooltip flex justify-center items-center h-fit"
                      >
                        <FaRegSave /> <p className="tooltiptext ">Save</p>
                      </button>
                    )}
                  </div>
                )}
              </div>
              <div
                className="border-[1px] border-gray-100 "
                style={{ margin: "0" }}
              ></div>
              <div className="p-6">
                <p className=" font-semibold">Job description:</p>
                <ReactQuill
                  value={jobdescription}
                  onChange={(value) => setJobDescription(value)}
                  readOnly={props.applicants.length === 0 ? !isEdit : true}
                  theme="bubble"
                  className={`${isGeneratingPDF ? "" : "custom-quill"}`}
                />
                {/* <div className="text-[#8F94A1] " dangerouslySetInnerHTML={{__html: jobDetails.jobdescription}}></div> */}
              </div>

              {!isGeneratingPDF && (
                <>
                  <div
                    className="border-[1px] border-gray-100"
                    style={{ margin: "0" }}
                  ></div>
                  <div
                    className="page-break"
                    style={{ pageBreakBefore: "always" }}
                  ></div>
                  {(() => {
                    const assessments = [
                      {
                        enabled: jobDetails?.aiinterviewenabled,
                        provider: "AI Interview",
                      },
                      {
                        enabled: jobDetails?.hackerrank_enabled,
                        provider: "HackerRank",
                        name: jobDetails?.hackerrank_test_name,
                        validityFrom: jobDetails?.invited_valid_from,
                        validityTo: jobDetails?.invited_valid_to,
                      },
                      {
                        enabled: jobDetails?.coderbyte_enabled,
                        provider: "Coderbyte",
                        name: jobDetails?.coderbyte_test_name,
                        validityFrom: jobDetails?.invited_valid_from,
                        validityTo: jobDetails?.invited_valid_to,
                      },
                    ].filter((a) => a.enabled);

                    if (assessments.length === 0) return null;

                    return (
                      <div className="p-6 flex flex-col gap-2">
                        <p className="font-semibold">Assessments:</p>
                        <div className="flex flex-col gap-4">
                          {assessments.map((assessment) => (
                            <div key={assessment.provider} className="flex flex-col gap-1">
                              <p className="font-semibold">{assessment.provider}</p>
                              {assessment.provider === "AI Interview" ? (
                                <div className="flex flex-col gap-4 ml-6">
                                  {/* Preferred language */}
                                  <p className="font-semibold text-[#444D63]">
                                    Preferred language for receiving interview responses:{" "}
                                    <span className="text-[#8F94A1] font-normal">
                                      {jobDetails.preferredlanguage === "HI"
                                        ? "Hindi"
                                        : "English"}
                                    </span>
                                  </p>

                                  {/* Technical Questions */}
                                  <div className="flex flex-col gap-1">
                                    <p className="font-semibold text-[#444D63]">Technical Questions:</p>
                                    <ul className="list-disc ml-6 flex flex-col gap-1">
                                      {techQuestions.map((question, index) => (
                                        <li key={index} className="font-normal text-[#8F94A1]">
                                          {question.Question}
                                        </li>
                                      ))}
                                    </ul>
                                  </div>

                                  {/* AI Interview Logic */}
                                  <div className="flex flex-col gap-1">
                                    <p className="font-semibold text-[#444D63]">AI Interview Logic:</p>
                                    <div className="flex w-full ">
                                      <p className="font-semibold w-1/2 text-[#444D63]">
                                        Trigger AI Interview:{" "}
                                        <span className="text-[#8F94A1] font-normal">
                                          {!manualTrigger
                                            ? "Resume Compatibility Score"
                                            : "Manually"}
                                        </span>
                                      </p>
                                      {!manualTrigger && (
                                        <p className="font-semibold w-1/2 text-[#444D63]">
                                          Threshold:{" "}
                                          <span className="text-[#8F94A1] font-normal">
                                            {trigger}
                                          </span>
                                        </p>
                                      )}
                                    </div>
                                  </div>

                                  {/* Skills Weightage */}
                                  <div className="flex flex-col gap-1">
                                    <p className="font-semibold text-[#444D63]">Skills weightage:</p>
                                    <div className="flex space-x-5">
                                      <p className="font-semibold w-1/2 text-[#444D63]">
                                        Resume Score:{" "}
                                        <span className="text-[#8F94A1] font-normal">
                                          {jobDetails.resumecompatibility}
                                        </span>
                                      </p>
                                      <p className="font-semibold w-1/2 text-[#444D63]">
                                        Employability skills score:{" "}
                                        <span className="text-[#8F94A1] font-normal">
                                          {jobDetails.aiscore}
                                        </span>
                                      </p>
                                      <p className="font-semibold w-1/2 text-[#444D63]">
                                        Voice Score:{" "}
                                        <span className="text-[#8F94A1] font-normal">
                                          {jobDetails.voiceanalysisscore}
                                        </span>
                                      </p>
                                      {jobDetails.technicalweight > 0 && (
                                        <p className="font-semibold w-1/2 text-[#444D63]">
                                          Technical score:{" "}
                                          <span className="text-[#8F94A1] font-normal">
                                            {jobDetails.technicalweight}
                                          </span>
                                        </p>
                                      )}
                                    </div>
                                  </div>
                                </div>
                              ) : (
                                <div className="flex w-full gap-4 ml-6">
                                  <p className="font-semibold w-1/2 text-[#444D63]">
                                    Assessment Name:{" "}
                                    <span className="font-normal text-[#8F94A1]">{assessment.name || "-"}</span>
                                  </p>
                                  <p className="font-semibold w-1/2 text-[#444D63]">
                                    Validity:{" "}
                                    <span className="font-normal text-[#8F94A1]">
                                      {assessment.validityFrom && assessment.validityTo
                                        ? `${formatDateToShortMonth(assessment.validityFrom)} to ${formatDateToShortMonth(assessment.validityTo)}`
                                        : "-"}
                                    </span>
                                  </p>
                                </div>
                              )}
                            </div>
                          ))}
                        </div>
                      </div>
                    );
                  })()}
                  <div
                    className="border-[1px] border-gray-100 m-0"
                    style={{ margin: "0" }}
                  ></div>
                  <div className="p-6 flex flex-col gap-2">
                    <p className="font-semibold">
                      Recruiter & Hiring Manager Details:
                    </p>

                    <div className="flex gap-2">
                      {isEdit ? (
                        <div className="w-1/2 flex gap-2 items-center">
                          <p className="font-semibold">Select recruiter</p>
                          <Select
                            options={getFilteredOptions(recruiters, recruiter)}
                            // Set the pre-selected value based on recruiter state
                            defaultValue={recruiters.find(
                              (rec) => rec.uuid === jobDetails.assignrecruiter,
                            )}
                            onChange={(option) => {
                              if (option != null) {
                                setRecuiter(option.value);
                              }
                            }}
                            isClearable={true}
                            className="mt-3"
                          />
                        </div>
                      ) : (
                        <p className="font-semibold w-1/2 text-[#444D63]">
                          Recruiter:{" "}
                          <span className="text-[#444D63] font-normal">
                            {
                              // Find recruiter by uuid and display name
                              (
                                recruiters.find(
                                  (rec) =>
                                    rec.uuid === jobDetails.assignrecruiter,
                                ) || {}
                              ).name
                            }
                          </span>
                        </p>
                      )}
                      {isEdit ? (
                        <div className="w-1/2 flex gap-2 items-center">
                          <p className="font-semibold text-[#444D63]">Additional Recruiters:</p>
                          <div>
                            <Select
                              options={getFilteredOptions(
                                recruiters,
                                additionalRecruitersAndHrms.additionalRecruiters,
                              )}
                              onChange={(option) => {
                                setAdditionalRecruitersAndHrms({
                                  ...additionalRecruitersAndHrms,
                                  additionalRecruiters: Array.isArray(option)
                                    ? option
                                    : [],
                                });
                              }}
                              isMulti
                              className="mt-3"
                              value={
                                additionalRecruitersAndHrms.additionalRecruiters
                              }
                            />
                          </div>
                        </div>
                      ) : (
                        <p className="font-semibold w-1/2 text-[#444D63]">
                          Additional Recruiters:{" "}
                          <span className="text-[#444D63] font-normal">
                            {jobDetails.additional_recruiters
                              ?.map(
                                (recruiter) =>
                                  allUsers.find(
                                    (user) => user.uuid === recruiter,
                                  )?.name,
                              )
                              .join(", ") || ""}
                          </span>
                        </p>
                      )}
                    </div>

                    <div className="flex gap-2">
                      {isEdit ? (
                        <div className="w-1/2 flex gap-2 items-center">
                          <p className="font-semibold">Select hiring manager</p>
                          <Select
                            options={getFilteredOptions(
                              formattedAllUsers,
                              manager,
                            )}
                            defaultValue={formattedAllUsers.find(
                              (rec) =>
                                rec.uuid === jobDetails.assignhiringmanager,
                            )}
                            onChange={(option) => {
                              if (option != null) {
                                setManager(option.value);
                              }
                            }}
                            isClearable="true"
                            className="mt-3"
                          />
                        </div>
                      ) : (
                        <p className="font-semibold w-1/2 text-[#444D63]">
                          Hiring Manager:{" "}
                          <span className="text-[#444D63] font-normal">
                            {
                              (
                                formattedAllUsers.find(
                                  (rec) =>
                                    rec.uuid === jobDetails.assignhiringmanager,
                                ) || {}
                              ).name
                            }
                          </span>
                        </p>
                      )}

                      {isEdit ? (
                        <div className="w-1/2 flex gap-2 items-center">
                          <p className="font-semibold text-[#444D63]">
                            Additional Hiring Managers:
                          </p>
                          <div>
                            <Select
                              options={getFilteredOptions(
                                formattedAllUsers,
                                additionalRecruitersAndHrms.additionalHrms,
                              )}
                              onChange={(option) => {
                                setAdditionalRecruitersAndHrms({
                                  ...additionalRecruitersAndHrms,
                                  additionalHrms: Array.isArray(option)
                                    ? option
                                    : [],
                                });
                              }}
                              isMulti
                              className="mt-3"
                              value={
                                additionalRecruitersAndHrms.additionalHrms
                              }
                            />
                          </div>
                        </div>
                      ) : (
                        <p className="font-semibold w-1/2 text-[#444D63]">
                          Additional Hiring Managers:{" "}
                          <span className="text-[#444D63] font-normal">
                            {jobDetails.additional_hrms
                              ?.map(
                                (hrm) =>
                                  allUsers.find((user) => user.uuid === hrm)
                                    ?.name,
                              )
                              .join(", ") || ""}
                          </span>
                        </p>
                      )}
                    </div>

                    {jobDetails?.approval_history && (
                      <div className="flex gap-2">
                        <p className="font-semibold w-1/2 text-[#444D63]">
                          {jobDetails?.approval_history?.[
                            jobDetails?.approval_history?.length - 1
                          ].action === "approve"
                            ? "Approved"
                            : "Rejected"}{" "}
                          by:{" "}
                          <span className="text-[#444D63] font-normal">
                            {
                              jobDetails?.approval_history?.[
                                jobDetails?.approval_history?.length - 1
                              ].name
                            }
                          </span>
                        </p>
                      </div>
                    )}
                  </div>
                  {" "}
                </>
              )}
              <div
                className="border-[1px] border-gray-100 m-0"
                style={{ margin: "0" }}
              ></div>
              {isEdit && (
                <div className="p-6">
                  <div className="flex justify-between">
                    <button
                      className="border-blue-400 border text-blue-400 outline-none px-5 py-2 rounded-lg"
                      onClick={() => {
                        setIsEdit(false);
                      }}
                    >
                      Cancel
                    </button>
                    <button
                      onClick={() => {
                        jobSubmit();
                      }}
                      className=" text-white bg-blue-500 outline-none px-5 py-2 rounded-lg"
                    >
                      {Loader ? (
                        <TailSpin
                          color="white"
                          height="30"
                          width="30"
                        ></TailSpin>
                      ) : (
                        "Save"
                      )}
                    </button>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default JobDetails;
